// const new_service_basis = window.gtaAiConfig.service_basis

/* eslint-disable */

let tag = process.env.VUE_APP_TAG
let new_service_basis = getEnv(tag).service_basis

export default {
  // 我的模型
  /**
   * 查询训练模型版本信息，模型训练列表
   */
  getTrainModelByModelId: `${new_service_basis}/ai/training/modelCenter/getTrainModelByModelId`,
  /**
   * 查询当前账号下我的模型列表
   */
  getMyModelList: `${new_service_basis}/ai/training/modelCenter/getMyModelList`,
  /**
   * 查询模型类型
   */
  getModelType: `${new_service_basis}/ai/training/modelCenter/getModelType`,
  /**
   *  查询模型数据下拉框
   */
  getModelData: `${new_service_basis}/ai/training/modelCenter/getModelData`,
  /**
   *  创建模型
   */
  addModel: `${new_service_basis}/ai/training/modelCenter/addModel`,
  /**
   *  修改模型
   */
  updateModel: `${new_service_basis}/ai/training/modelCenter/updateModel`,
  /**
   *  删除模型
   */
  deleteModel: `${new_service_basis}/ai/training/modelCenter/deleteModel`,
  /**
   *  删除训练模型
   */
  deleteTrainingModel: `${new_service_basis}/ai/training/modelCenter/deleteTrainingModel`,
  /**
   *  获取模型报告
   */
  getAssessmentReport: `${new_service_basis}/ai/training/modelCenter/getAssessmentReport`,

  // 数据集中心接口
  /**
   *  创建数据集
   */
  addDataset: `${new_service_basis}/ai/training/dataCenter/addDataset`,
  /**
   *  查询当前账号下我的数据集列表
   */
  getMyDatasetList: `${new_service_basis}/ai/training/dataCenter/getMyDatasetList`,
  /**
   *  查询数据集版本列表
   */
  getMyDatasetVersionList: `${new_service_basis}/ai/training/dataCenter/getMyDatasetVersionList`,

  /**
   *  分类/标注查询当前数据集列表
   */
  selectDataset: `${new_service_basis}/ai/training/dataCenter/selectDataset`,
  /**
   *  选择数据集版本下拉框接口
   */
  selectDatasetVersion: `${new_service_basis}/ai/training/dataCenter/selectDatasetVersion`,
  /**
   *  选择数据集已发布版本下拉框接口
   */
  selectDatasetReleaseVersion: `${new_service_basis}/ai/training/dataCenter/selectDatasetReleaseVersion`,
  /**
   *  修改数据集
   */
  updateDataset: `${new_service_basis}/ai/training/dataCenter/updateDataset`,
  /**
   *  删除数据集
   */
  deleteDataset: `${new_service_basis}/ai/training/dataCenter/deleteDataset`,
  /**
   *  发布数据集
   */
   releaseDataset: `${new_service_basis}/ai/training/dataCenter/releaseDataset`,
  /**
   *  复制数据集
   */
   copyDataset: `${new_service_basis}/ai/training/dataCenter/copyDataset`,
  /**
   *  根据数据集id查询 图像筛选设置的参数
   */
  getBehaviorByDatasetId: `${new_service_basis}/ai/training/dataCenter/getBehaviorByDatasetId`,
  /**
   *  根据数据集id查询标签 标签分类(无返回每个标签分类数量)
   */
  getLabelByDatasetId: `${new_service_basis}/ai/training/dataCenter/getLabelByDatasetId`,
  /**
   *  根据数据集id查询标签 标签分类(有返回每个标签分类数量)
   */
  getLabelNumByDatasetId: `${new_service_basis}/ai/training/dataCenter/getLabelNumByDatasetId`,
  /**
   *  创建标签 分类标签
   */
  addLabel: `${new_service_basis}/ai/training/dataCenter/addLabel`,
  /**
   *  编辑标签
   */
  updateLabelBylabelId: `${new_service_basis}/ai/training/dataCenter/updateLabelByLabelId`,
  /**
   *  删除标签
   */
  deleteLabelBylabelId: `${new_service_basis}/ai/training/dataCenter/deleteLabelByLabelId`,
  /**
   * 图像分类  根据标签id查询图片列表/ai/training/dataCenter/getImgByLabelId
   根据标签id查询图片列表
   */
  getImgBylabelId: `${new_service_basis}/ai/training/dataCenter/getImgByLabelId`,
  /**
   *  根据数据集id和标签id查询图片列表
   */
  getImgByDatasetId: `${new_service_basis}/ai/training/dataCenter/getImgByDatasetId`,
  /**
   *  物体检测 根据标签id查询图片列表
   */
  getImgByLabelIdList: `${new_service_basis}/ai/training/dataCenter/getImgByLabelIdList`,

  /**
   *  批量上传图片
   */
  uploadImgBylabelId: `${new_service_basis}/ai/training/dataCenter/uploadImgByLabelId`,
  /**
   *  修改图片名称
   */
  updateImgByImgId: `${new_service_basis}/ai/training/dataCenter/updateImgByImgId`,
  /**
   * 删除图片
   */
  deleteImgByImgId: `${new_service_basis}/ai/training/dataCenter/deleteImgByImgId`,
  /**
   * 修改图片是否符合条件状态
   */
  updateImgIsQualifiedByImgId: `${new_service_basis}/ai/training/dataCenter/updateImgIsQualifiedByImgId`,
  /**
   * 根据用户设置筛选图片
   */
  screenImg: `${new_service_basis}/ai/training/dataCenter/screenImg`,

  /**
   * 新增训练模型
   */
  addTrainModel: `${new_service_basis}/ai/training/modelCenter/addTrainModel`,
  /**
   * 选择模型版本下拉框
   */
  getModelVersion: `${new_service_basis}/ai/training/modelCenter/getModelVersion`,
  /**
   *  查询训练模型下拉框
   */
  getVerifyModel: `${new_service_basis}/ai/training/modelCenter/getVerifyModel`,
  /**
   *  校验模型：图片分类、物体检测、文本分类、文本标注、音频分类
   */
  verifyModel: `${new_service_basis}/ai/training/modelCenter/verifyModel`,
  /**
   *  校验模型：音频标注
   */
  verifyAudioTagModel: `${new_service_basis}/ai/training/modelCenter/verifyAudioTagModel`,
  /**
   *  根据图片id查询图片标注数据
   */
  getImgTagByImgId: `${new_service_basis}/ai/training/dataCenter/getImgTagByImgId`,
  /**
   *  根据图片id标注图片
   */
  updateImgTagByImgId: `${new_service_basis}/ai/training/dataCenter/updateImgTagByImgId`,
  /**
   *  发布训练模型
   */
  releaseModel: `${new_service_basis}/ai/training/modelCenter/releaseModel`,
  /**
   *  修改模型公开状态
   */
  updateIsPublic: `${new_service_basis}/ai/training/modelCenter/updateIsPublic`,

  // 文本分类、文本标注
  /**
   *  根据标签id查询文本分类列表
   */
  getTextByLabelId: `${new_service_basis}/ai/training/dataCenter/getTextByLabelId`,
  /**
   *  批量上传文本
   */
  uploadTextByLabelId: `${new_service_basis}/ai/training/dataCenter/uploadTextByLabelId`,
  /**
   *  修改文本名称
   */
  updateTextByTextId: `${new_service_basis}/ai/training/dataCenter/updateTextByTextId`,
  /**
   *  删除文本
   */
  deleteTextByTextId: `${new_service_basis}/ai/training/dataCenter/deleteTextByTextId`,
  /**
   *  根据数据集id查询文本列表-文本标注
   */
  getTextByDatasetId: `${new_service_basis}/ai/training/dataCenter/getTextByDatasetId`,
  /**
   *  根据标签id查询文本列表-文本标注
   */
  getTextByLabelIdList: `${new_service_basis}/ai/training/dataCenter/getTextByLabelIdList`,
  /**
   *  根据文本id标注文本-文本标注
   */
  updateTextTagByTextId: `${new_service_basis}/ai/training/dataCenter/updateTextTagByTextId`,
  /**
   *  根据文本id查询文本标注数据-文本标注
   */
  getTextTagByTextId: `${new_service_basis}/ai/training/dataCenter/getTextTagByTextId`,
  /**
   *  根据标签id查询文本标注数据-文本标注
   */
  getTextTagByLabelId: `${new_service_basis}/ai/training/dataCenter/getTextTagByLabelId`,

  /**
   *  根据标签id查询标注数量
   */
  getTagNumByLabelIds: `${new_service_basis}/ai/training/dataCenter/getTagNumByLabelIds`,

  // 音频分类、音频标注
  /**
   *  音频分类：根据音频id查询音频列表
   */
  getAudioByLabelId: `${new_service_basis}/ai/training/dataCenter/getAudioByLabelId`,
  /**
   *  修改音频名称
   */
  updateAudioByAudioId: `${new_service_basis}/ai/training/dataCenter/updateAudioByAudioId`,
  /**
   *  删除音频
   */
  deleteAudioByAudioId: `${new_service_basis}/ai/training/dataCenter/deleteAudioByAudioId`,
  /**
   *  批量上传音频
   */
  uploadAudio: `${new_service_basis}/ai/training/dataCenter/uploadAudio`,
  /**
   *  音频标注:根据数据集id查询音频列表
   */
  getAudioByDatasetId: `${new_service_basis}/ai/training/dataCenter/getAudioByDatasetId`,
  /**
   *  音频标注:根据标签id查询音频列表
   */
  getAudioByLabelIdList: `${new_service_basis}/ai/training/dataCenter/getAudioByLabelIdList`,
  /**
   *  音频标注:根据音频id标注音频
   */
  updateAudioTagByAudioId: `${new_service_basis}/ai/training/dataCenter/updateAudioTagByAudioId`,
  /**
   *   音频标注:根据音频id查询音频标注数据
   */
  getAudioTagByAudioId: `${new_service_basis}/ai/training/dataCenter/getAudioTagByAudioId`,

  // 模型训练-训练配置
  /**
   *  查询模型版本配置下拉框
   */
  getModelConfigSelect: `${new_service_basis}/ai/training/modelCenter/getModelConfigSelect`,
  /**
   *  根据模型版本查看配置信息
   */
  getConfigByModelVersion: `${new_service_basis}/ai/training/modelCenter/getConfigByModelVersion`,
  /**
   *  查询增量学习下拉框
   */
  getIncrementalLearningSelect: `${new_service_basis}/ai/training/modelCenter/getIncrementalLearningSelect`,
  /**
   *  查询验证集列表
   */
  getValidationSetList: `${new_service_basis}/ai/training/dataCenter/getValidationSetList`,
  /**
   *  查询测试集列表
   */
  getTestSetList: `${new_service_basis}/ai/training/dataCenter/getTestSetList`,
}
